export class KeyValueObject {

    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

	id: number;
    name: string;
    groupName: string;
    groupId: number;
    integraCode: string;
    disabled: boolean;
    isDefault: boolean = false;
    requiresTransferWarning?: boolean;
    skipInventory?: boolean;
}
